import React, { useState, useEffect } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CRow } from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import { cilSearch } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import PermissionsNoPage, { Permissions } from 'src/components/Permissions';

const page = 1;
const urlApi = '/log_history_requests';

export async function LoaderLogHistoryRequests() {
  const res = await AxiosInstance.get(`${urlApi}?page=${page}`).then((response) => response);
  return res;
}

const LogHistoryRequests = ({ user_data }) => {
  // if (!Permissions(user_data, 'AppRequests', 'VIEW_APPREQUESTS')) {
  //   return <PermissionsNoPage />;
  // }
  const { data } = useLoaderData();

  const [rows, setRows] = useState(data['hydra:member'] || []);
  const [rowCountState, setRowCountState] = useState(data['hydra:totalItems'] || 0);

  useEffect(() => {
    setRows(data['hydra:member'] || []);
    setRowCountState(data['hydra:totalItems'] || 0);
  }, [data]);

  const handlePageChange = (page) => {
    AxiosInstance.get(`${urlApi}?page=${page + 1}`).then((response) => {
      setRows(response.data['hydra:member']);
      setRowCountState(response.data['hydra:totalItems']);
    });
  };

  const columns = [
    { field: 'id', headerName: 'ID', width: 80 },
    { field: 'method', headerName: 'Метод', width: 220 },
    {
      field: 'status',
      headerName: 'Статус',
      width: 140,
    },
    {
      field: 'requestAccount',
      headerName: 'Рахунок / значення',
      width: 260,
      valueGetter: (params) =>
        params.row.request?.account || params.row.request?.value || '',
    },
    {
      field: 'requestOwner',
      headerName: 'Owner',
      width: 140,
      valueGetter: (params) => params.row.request?.owner || '',
    },
    {
      field: 'action',
      headerName: 'Переглянути',
      width: 120,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => (
        <Link
          to={`/log-history-requests/view/${params.row.id}`}
          className="cutom-view-icon"
        >
          <CIcon icon={cilSearch} customClassName="nav-icon" height={18} />
        </Link>
      ),
    },
  ];

  return (
    <CRow>
      <CCol xs={12}>
        <CCard className="mb-4">
          <CCardHeader>
            <strong>Запити в додаток</strong>
          </CCardHeader>
          <CCardBody>
            <div style={{ height: 600, width: '100%' }}>
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={30}
                rowsPerPageOptions={[30]}
                pagination
                rowCount={rowCountState}
                paginationMode="server"
                onPageChange={handlePageChange}
              />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default LogHistoryRequests;


